export default [


    //钢琴

    {
        id: 1,
        title: '钢琴',
        category: 'piano',
        categories: [
            {
                cover: '1-7.jpg',
                name: 'DCFX ENPRO',
                id: 7
            },
            {
                cover: '1-2.jpg',
                name: 'DC7X ENPRO',
                id: 2
            },
            {
                cover: '1-6.jpg',
                name: 'DC3X ENPRO',
                id: 6
            },
            {
                cover: '1-9.jpg',
                name: 'U1TA2',
                id: 9
            },
            {
                cover: '1-12.jpg',
                name: 'N1X',
                id: 12
            },
            {
                cover: '1-11.jpg',
                name: 'N3X',
                id: 11
            },
            {
                cover: '1-5.jpg',
                name: 'NU1X',
                id: 5
            },
            {
                cover: '1-4.jpg',
                name: 'CFX',
                id: 4
            },
            {
                cover: '1-1.jpg',
                name: 'DGC1 ENST PWH',
                id: 1
            },
            {
                cover: '1-13.jpg',
                name: 'S5X',
                id: 13
            },
            {
                cover: '1-14.jpg',
                name: 'CF4',
                id: 14
            },
            {
                cover: '1-15.jpg',
                name: 'CF6',
                id: 15
            },
            {
                cover: '1-8.jpg',
                name: '280VC DISKLAVIER EDITION',
                id: 8
            },
            {
                cover: '1-3.jpg',
                name: '280VC',
                id: 3
            },
            {
                cover: '1-16.jpg',
                name: 'Dragonfly PWH',
                id: 16
            }
        ]
    },

    //电子键盘

    {
        id: 2,
        title: '电子键盘',
        category: 'ekb',
        categories: [
            {
                cover: '2-1.jpg',
                name: 'CVP-809GP',
                id: 1
            },
            {
                cover: '2-2.jpg',
                name: 'CVP-809B/PE',
                id: 2
            },
            {
                cover: '2-3.jpg',
                name: 'CLP-695GPWH',
                id: 3
            },
            {
                cover: '2-4.jpg',
                name: 'CLP-685PE',
                id: 4
            },
            {
                cover: '2-5.jpg',
                name: 'CSP-170B',
                id: 5
            },
            {
                cover: '2-6.jpg',
                name: 'GENOS',
                id: 6
            },
            {
                cover: '2-7.jpg',
                name: 'PSR-SX900',
                id: 7
            },
            {
                cover: '2-8.jpg',
                name: 'PSR-SX700',
                id: 8
            },
            {
                cover: '2-10.jpg',
                name: 'SHS-500B',
                id: 10
            },
            {
                cover: '2-11.jpg',
                name: 'SHS-500RD',
                id: 11
            },
            {
                cover: '2-12.jpg',
                name: 'PSR-E360DW',
                id: 12
            },
            {
                cover: '2-13.jpg',
                name: 'PSR-E360MA',
                id: 13
            },
            {
                cover: '2-14.jpg',
                name: 'KB-309',
                id: 14
            },
            {
                cover: '2-15.jpg',
                name: 'KB-308',
                id: 15
            },
            {
                cover: '2-16.jpg',
                name: 'PSS-F30',
                id: 16
            },
            {
                cover: '2-17.jpg',
                name: 'PSS-E30',
                id: 17
            },
            {
                cover: '2-18.jpg',
                name: 'PSS-A50',
                id: 18
            },
            {
                cover: '2-19.jpg',
                name: 'ELC-02',
                id: 19
            }
        ]
    },



    //管乐

    {
        id: 4,
        title: '管乐器',
        category: 'wind',
        categories: [
            {
                cover: '3-1.jpg',
                name: 'YFL-897H',
                id: 1
            },
            {
                cover: '3-2.jpg',
                name: 'Xeno Artist',
                id: 2
            },
            {
                cover: '3-3.jpg',
                name: 'YTR-8340EM',
                id: 3
            },
            {
                cover: '3-4.jpg',
                name: 'YCL-SEARTISTMODEL',
                id: 4
            },
            {
                cover: '3-5.jpg',
                name: 'YAS-875EX',
                id: 5
            },
            {
                cover: '3-6.jpg',
                name: 'YSL-8820R',
                id: 6
            },
            {
                cover: '3-7.jpg',
                name: 'YHR-891',
                id: 7
            },
            {
                cover: '3-8.jpg',
                name: 'Venova',
                id: 8
            }
        ]
    },






    //吉他

    {
        id: 3,
        title: '电声乐器',
        category: 'guitar',
        categories: [
            {
                cover: '4-1.jpg',
                name: 'LL36//ARE',
                id: 1
            },
            {
                cover: '4-2.jpg',
                name: 'LS26//ARE',
                id: 2
            },
            {
                cover: '4-3.jpg',
                name: 'LJ26//ARE',
                id: 3
            },
            {
                cover: '4-4.jpg',
                name: 'GC42S',
                id: 4
            },
            {
                cover: '4-5.jpg',
                name: 'GC42C',
                id: 5
            },
            {
                cover: '4-6.jpg',
                name: 'FGX5/FSX5/FG5',
                id: 6
            },
            {
                cover: '4-7.jpg',
                name: 'A5R ARE/AC5R ARE',
                id: 7
            },
            {
                cover: '4-8.jpg',
                name: 'LL-TA/FS-TA/CSF-TA/CG-TA',
                id: 8
            },
            {
                cover: '4-9.jpg',
                name: 'SLG200NW',
                id: 9
            },
            {
                cover: '4-10.jpg',
                name: 'SLG200N',
                id: 10
            },
            {
                cover: '4-11.jpg',
                name: 'SLG200S',
                id: 11
            },
            {
                cover: '4-12.jpg',
                name: 'PACIFICA612VIIFM',
                id: 12
            },
            {
                cover: '4-13.jpg',
                name: 'RSP20CR',
                id: 13
            },
            {
                cover: '4-14.jpg',
                name: 'RS720B',
                id: 14
            },
            {
                cover: '4-15.jpg',
                name: 'RS720BX',
                id: 15
            },
            {
                cover: '4-16.jpg',
                name: 'RS502T',
                id: 16
            },
            {
                cover: '4-17.jpg',
                name: 'TRBX604FM',
                id: 17
            },
            {
                cover: '4-18.jpg',
                name: 'TRBX605FM',
                id: 18
            },
            {
                cover: '4-19.jpg',
                name: 'BBP35',
                id: 19
            },
            {
                cover: '4-20.jpg',
                name: 'BB734A',
                id: 20
            },
            {
                cover: '4-21.jpg',
                name: 'Live Custom  Hybrid Oak',
                id: 21
            },
            {
                cover: '4-22.jpg',
                name: 'DTX920K',
                id: 22
            },
            {
                cover: '4-23.jpg',
                name: 'DTX582K',
                id: 23
            },
            {
                cover: '4-24.jpg',
                name: 'MONTAGE8 WH',
                id: 24
            },
            {
                cover: '4-25.jpg',
                name: 'MONTAGE7 WH',
                id: 25
            },
            {
                cover: '4-26.jpg',
                name: 'MONTAGE6 WH',
                id: 26
            },
            {
                cover: '4-27.jpg',
                name: 'MODX7/MODX8',
                id: 27
            },
            {
                cover: '4-28.jpg',
                name: 'CP88/CP73',
                id: 28
            }
        ]
    },





    //家庭音响

    {
        id: 5,
        title: '家庭音响',
        category: 'av',
        categories: [
            {
                cover: '5-2.jpg',
                name: 'NS-5000',
                id: 2
            },
            {
                cover: '5-3.jpg',
                name: 'SPS-5000',
                id: 3
            },
            {
                cover: '5-4.jpg',
                name: 'M-5000',
                id: 4
            },
            {
                cover: '5-5.jpg',
                name: 'C-5000',
                id: 5
            }
        ]
    }




]